module.exports = __webpack_public_path__ + "labioplastika_01_20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akce/labioplastika_01_20.jpg
// module id = 841
// module chunks = 0